import React from 'react';
import { Check } from 'lucide-react';

const MAYA_IMG =
  'https://customer-assets.emergentagent.com/job_917f1f6f-34a3-44d2-add9-bbc18cf35d15/' +
  'artifacts/7qelqbu3_Californina%20businesswoman%20age%2046s%20with%20hazel%20green%20eyes%2C' +
  '%20long%20chestnut%20hair.jpg';

const AVAS = [
  { name: 'Maya', role: 'Your Guide', img: MAYA_IMG, desc: 'Sets everything up, explains how HiBFF works, always in your dashboard.', tier: 'guide' },
  { name: 'Rebecca', role: 'Knowledge Tutor', img: '/avas/rebecca.png', desc: 'Science and tech, taught Socratic-style so you find the answers yourself.', tier: 'free' },
  { name: 'Chloe', role: 'Friendships & Conflict', img: '/avas/chloe.jpg', desc: 'Friend drama, group projects and standing your ground kindly.', tier: 'free' },
  { name: 'Marcus', role: 'Careers & School', img: '/avas/marcus.jpg', desc: 'Job interviews and speaking up respectfully with teachers.', tier: 'free' },
  { name: 'Neo', role: 'Your Practice Friend', img: '/avas/neo.jpg', desc: 'Your companion through the 20 social fitness challenges.', tier: 'steady' },
  { name: 'Leo', role: 'Relationships', img: '/avas/leo.jpg', desc: 'Crushes, dating and difficult messages, rehearsed safely.', tier: 'steady' },
  { name: 'Ethan', role: 'Public Speaking', img: '/avas/ethan.jpg', desc: 'Presentations without the panic.', tier: 'steady' },
  { name: 'Sarah', role: 'Organization & Boundaries', img: '/avas/sarah.jpg', desc: 'Workload, time management, and saying no without guilt.', tier: 'together' },
  { name: 'Petra', role: 'Digital Life & Online Safety', img: '/avas/petra.jpg', desc: 'Group chat drama, cyberbullying, and staying in control online.', tier: 'together' },
];

const BADGE = { free: { label: 'TRY FOR FREE', cls: 'bg-emerald-500 text-white' } };

export const MeetTheAvAs = () => (
  <div className="mt-14 max-w-5xl mx-auto" data-testid="meet-the-avas">
    <h3 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-2" style={{ fontFamily: 'Georgia, serif' }}>
      Meet all 9 AvAs
    </h3>
    <p className="text-sm text-gray-600 text-center max-w-2xl mx-auto mb-8">
      Your free plan includes <strong>10 minutes of voice practice</strong> with the three highlighted below — enough for a real
      5-minute conversation with each. Subscribe to unlock the full team.
    </p>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3" style={{ gap: '16px' }}>
      {AVAS.map(a => {
        const isFree = a.tier === 'free';
        return (
          <div
            key={a.name}
            className={`p-4 bg-white rounded-2xl border-2 flex items-start gap-3 relative ${isFree ? 'border-emerald-400 shadow-md' : 'border-gray-200'}`}
            data-testid={`ava-card-${a.name.toLowerCase()}`}
          >
            <img
              src={a.img}
              alt={a.name}
              className={`w-16 h-16 rounded-full object-cover flex-shrink-0 ${isFree ? 'ring-2 ring-emerald-400 ring-offset-2' : ''}`}
              loading="lazy"
            />
            <div className="min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-bold text-gray-900">{a.name}</span>
                {isFree && (
                  <span className={`px-2 py-0.5 text-[10px] font-extrabold tracking-wider rounded-full inline-flex items-center gap-1 ${BADGE.free.cls}`} data-testid={`ava-badge-${a.name.toLowerCase()}`}>
                    <Check size={10} />
                    {BADGE.free.label}
                  </span>
                )}
              </div>
              <p className="text-xs font-semibold text-gray-500 mt-0.5">{a.role}</p>
              <p className="text-xs text-gray-600 mt-1 leading-relaxed">{a.desc}</p>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

export default MeetTheAvAs;
